export default __webpack_public_path__ + "static/romain-stackone-9bbbb312243c94c8f8256b609f83c1ac.jpeg";